import * as React from 'react';
import C from 'classnames';
export const Select = props => {
    return (React.createElement("select", { onChange: props.onChange, name: props.name, className: C('form-control', props.className), defaultValue: props.value, required: props.required, value: props.value },
        props.placeholder && (React.createElement("option", { key: "", value: "", disabled: true, selected: true, hidden: true }, props.placeholder)),
        props.options
            ? props.options.map(option => {
                return (React.createElement("option", { key: option.value, value: option.value }, option.label));
            })
            : props.noOptionsMessage && (React.createElement("option", { disabled: true }, props.noOptionsMessage))));
};
//# sourceMappingURL=Select.js.map